import { useContext } from 'react';
import { TourContext } from './TourContextValue';
import type { TourContextType } from '@/types/product-tour';

export function useTour(): TourContextType {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}
